(() => {
  'use strict';

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  const closeMenu = () => {
    if (!menuToggle || !mobileMenu) return;
    mobileMenu.hidden = true;
    menuToggle.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
  };

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const shouldOpen = mobileMenu.hidden;
      mobileMenu.hidden = !shouldOpen;
      menuToggle.classList.toggle('is-open', shouldOpen);
      menuToggle.setAttribute('aria-expanded', String(shouldOpen));
    });

    mobileMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
  }

  const searchDialog = document.querySelector('[data-search-dialog]');
  const searchOpeners = document.querySelectorAll('[data-open-search]');

  searchOpeners.forEach((opener) => {
    opener.addEventListener('click', () => {
      if (!searchDialog) return;
      if (typeof searchDialog.showModal === 'function') searchDialog.showModal();
      else searchDialog.setAttribute('open', '');
      window.setTimeout(() => searchDialog.querySelector('input[type="search"]')?.focus(), 50);
    });
  });

  searchDialog?.querySelector('[data-close-dialog]')?.addEventListener('click', () => searchDialog.close());
  searchDialog?.addEventListener('click', (event) => {
    if (event.target === searchDialog) searchDialog.close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });

  const normalizePath = (value) => {
    try {
      const path = new URL(value, window.location.origin).pathname.replace(/\/+$/, '');
      return path || '/';
    } catch (error) {
      return '/';
    }
  };

  const currentPath = normalizePath(window.location.href);
  if (document.body.classList.contains('template-404') && currentPath === '/promocje') {
    window.location.replace('/collections/promocje');
    return;
  }

  const navLinks = Array.from(document.querySelectorAll('.top-nav [data-nav-link]'));
  const exactMatch = navLinks.find((link) => normalizePath(link.href) === currentPath);
  const homeMatch = currentPath === '/' ? navLinks.find((link) => normalizePath(link.href) === '/') : null;
  navLinks.forEach((link) => link.classList.remove('is-active'));
  (exactMatch || homeMatch)?.classList.add('is-active');

  const mobileSeasonQuery = window.matchMedia('(max-width: 680px)');
  const seasonTabs = Array.from(document.querySelectorAll('[data-season-tab]'));
  const homePanelLinks = Array.from(document.querySelectorAll('[data-home-panel]'));
  const seasonPanels = Array.from(document.querySelectorAll('[data-season-products]'));
  const catalogTitle = document.querySelector('#catalog-title');

  const activateSeason = (season, title) => {
    seasonTabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.seasonTab === season));
    seasonPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.seasonProducts === season));
    if (catalogTitle && title) catalogTitle.textContent = title;
  };

  seasonTabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      if (!document.body.classList.contains('template-index') || !mobileSeasonQuery.matches) return;
      event.preventDefault();
      activateSeason(tab.dataset.seasonTab, tab.dataset.seasonTitle);
      document.querySelector('#produkty')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  homePanelLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!document.body.classList.contains('template-index') || !mobileSeasonQuery.matches) return;
      event.preventDefault();
      closeMenu();
      activateSeason(link.dataset.homePanel, link.dataset.homeTitle);
      document.querySelector('#produkty')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (document.body.classList.contains('template-index')) {
    const view = new URLSearchParams(window.location.search).get('view');
    const viewTitles = {
      shop: 'Sklep',
      sale: 'Promocje',
      new: 'Nowości',
      summer: 'Polecane na lato',
      autumn: 'Polecane na jesień',
      winter: 'Polecane na zimę',
      spring: 'Polecane na wiosnę',
    };
    if (view && viewTitles[view]) activateSeason(view, viewTitles[view]);
  }

  const productForm = document.querySelector('.product-page__form');
  const variantPicker = document.querySelector('[data-variant-picker]');
  const variantSelect = document.querySelector('[data-variant-select]');
  const variantButtons = Array.from(document.querySelectorAll('[data-variant-button]'));
  const variantMessage = document.querySelector('[data-variant-message]');
  const variantStatus = document.querySelector('[data-variant-status]');
  const productPrice = document.querySelector('[data-product-price]');
  const productSubmit = document.querySelector('[data-product-submit]');
  const mainProductImage = document.querySelector('.product-page__main-media img');
  const productThumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));

  const setProductImage = (src, alt) => {
    if (!mainProductImage || !src) return;
    mainProductImage.src = src;
    mainProductImage.removeAttribute('srcset');
    if (alt) mainProductImage.alt = alt;
  };

  productThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      productThumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setProductImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt);
    });
  });

  const showVariantWarning = () => {
    if (!variantPicker) return;
    variantPicker.classList.add('needs-selection');
    variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (variantMessage) variantMessage.hidden = false;
    if (variantStatus) variantStatus.textContent = 'Wybierz wariant, żeby dodać produkt';
  };

  const clearVariantWarning = () => {
    variantPicker?.classList.remove('needs-selection');
    if (variantMessage) variantMessage.hidden = true;
  };

  variantButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!variantSelect) return;
      variantSelect.value = button.dataset.variantId;
      variantButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
      if (productPrice && button.dataset.variantPrice) productPrice.textContent = button.dataset.variantPrice;
      const isAvailable = button.dataset.variantAvailable === 'true';
      if (variantStatus) variantStatus.textContent = isAvailable ? button.textContent.trim() : 'Ten wariant jest chwilowo niedostępny';
      if (productSubmit) productSubmit.disabled = !isAvailable;
      setProductImage(button.dataset.variantImage, button.dataset.variantAlt);
      clearVariantWarning();
    });
  });

  productForm?.addEventListener('submit', (event) => {
    if (!variantSelect) return;
    if (variantSelect.value) return;
    event.preventDefault();
    showVariantWarning();
  });

  if (window.location.hash === '#wybierz-wariant') {
    window.setTimeout(showVariantWarning, 250);
  }

  document.querySelectorAll('[data-quantity-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('[data-quantity-input]');
      if (!input) return;
      const step = Number(button.dataset.quantityStep || 0);
      const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
      input.value = String(nextValue);
    });
  });

  document.querySelectorAll('[data-cart-quantity-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement?.querySelector('input[name="updates[]"]');
      if (!input) return;
      const step = Number(button.dataset.cartQuantityStep || 0);
      const nextValue = Math.max(Number(input.min || 0), Number(input.value || 0) + step);
      input.value = String(nextValue);
    });
  });

  const addChoiceDialog = document.querySelector('[data-add-choice-dialog]');
  const addChoiceClosers = document.querySelectorAll('[data-add-choice-close]');
  const cartCount = document.querySelector('[data-cart-count]');

  const showAddChoice = () => {
    if (!addChoiceDialog) return;
    if (typeof addChoiceDialog.showModal === 'function') addChoiceDialog.showModal();
    else addChoiceDialog.setAttribute('open', '');
  };

  addChoiceClosers.forEach((button) => {
    button.addEventListener('click', () => {
      if (typeof addChoiceDialog?.close === 'function') addChoiceDialog.close();
      else addChoiceDialog?.removeAttribute('open');
    });
  });

  addChoiceDialog?.addEventListener('click', (event) => {
    if (event.target === addChoiceDialog) addChoiceDialog.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    if (form === productForm && variantSelect && !variantSelect.value) return;
    event.preventDefault();
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.disabled = true;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Add to cart failed');
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        if (cartCount) cartCount.textContent = String(cart.item_count);
      }
      showAddChoice();
    } catch (error) {
      form.submit();
    } finally {
      if (submitter) submitter.disabled = false;
    }
  });

  const favoritesKey = 'sezoniq:favorites';

  const readFavorites = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(favoritesKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const writeFavorites = (favorites) => {
    try {
      window.localStorage.setItem(favoritesKey, JSON.stringify(favorites));
    } catch (error) {
      return;
    }
  };

  const syncFavoriteButtons = () => {
    const favorites = readFavorites();
    document.querySelectorAll('[data-favorite-button]').forEach((button) => {
      const isActive = favorites.some((item) => item.id === button.dataset.productId);
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', `${isActive ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}: ${button.dataset.productTitle || 'Produkt'}`);
      button.textContent = isActive ? '♥' : '♡';
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const productId = button.dataset.productId;
    if (!productId) return;
    const favorites = readFavorites();
    const existingIndex = favorites.findIndex((item) => item.id === productId);
    if (existingIndex >= 0) {
      favorites.splice(existingIndex, 1);
    } else {
      favorites.push({
        id: productId,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
      });
    }
    writeFavorites(favorites);
    syncFavoriteButtons();
  });

  syncFavoriteButtons();

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-load-more]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const target = document.querySelector(button.dataset.loadMoreTarget);
    if (!target) return;

    const originalContent = button.innerHTML;
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = 'Wczytywanie…';

    try {
      const response = await fetch(button.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Load more failed');
      const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = nextDocument.querySelector(button.dataset.loadMoreSource);
      if (!source) throw new Error('Product grid missing');

      const existingIds = new Set(
        Array.from(target.querySelectorAll('.product-card[data-product-id]')).map((card) => card.dataset.productId),
      );

      source.querySelectorAll('.product-card').forEach((card) => {
        const productId = card.dataset.productId;
        if (productId && existingIds.has(productId)) return;
        if (productId) existingIds.add(productId);
        target.appendChild(document.importNode(card, true));
      });

      const nextButton = nextDocument.querySelector('[data-load-more]');
      if (nextButton) {
        button.href = new URL(nextButton.getAttribute('href'), response.url).href;
        button.innerHTML = originalContent;
        button.removeAttribute('aria-busy');
      } else {
        button.closest('[data-load-more-pagination]')?.remove();
      }

      syncFavoriteButtons();
    } catch (error) {
      button.innerHTML = 'Spróbuj ponownie';
      button.removeAttribute('aria-busy');
    }
  });

  const weatherButton = document.querySelector('[data-check-weather]');
  const weatherTemperature = document.querySelector('[data-weather-temperature]');
  const weatherLead = document.querySelector('[data-weather-lead]');
  const weatherDescription = document.querySelector('[data-weather-description]');
  const weatherIcon = document.querySelector('[data-weather-icon]');

  const weatherCopy = (code) => {
    if (code === 0) return ['Słonecznie!', 'Idealny dzień na aktywność na świeżym powietrzu.', '☀'];
    if ([1, 2, 3].includes(code)) return ['Częściowe zachmurzenie', 'Pogoda dobra na spacer i krótką wycieczkę.', '⛅'];
    if ([45, 48].includes(code)) return ['Mglisto', 'Zabierz odblaski i coś ciepłego.', '🌫'];
    if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(code)) return ['Deszczowo', 'Przyda się ochrona przed deszczem.', '☂'];
    if ([71, 73, 75, 77, 85, 86].includes(code)) return ['Śnieżnie', 'Czas na ciepłe akcesoria i zimowe aktywności.', '❄'];
    if ([95, 96, 99].includes(code)) return ['Burzowo', 'Zostań w bezpiecznym miejscu i śledź prognozę.', '⚡'];
    return ['Zmienna pogoda', 'Sprawdź wyposażenie odpowiednie do warunków.', '◌'];
  };

  weatherButton?.addEventListener('click', () => {
    if (!navigator.geolocation) {
      if (weatherDescription) weatherDescription.textContent = window.sezoniqTheme?.locationError || 'Lokalizacja jest niedostępna.';
      return;
    }

    weatherButton.disabled = true;
    weatherButton.textContent = 'Sprawdzam…';
    navigator.geolocation.getCurrentPosition(async ({ coords }) => {
      try {
        const endpoint = new URL('https://api.open-meteo.com/v1/forecast');
        endpoint.search = new URLSearchParams({
          latitude: coords.latitude,
          longitude: coords.longitude,
          current: 'temperature_2m,weather_code',
          timezone: 'auto',
        }).toString();
        const response = await fetch(endpoint);
        if (!response.ok) throw new Error('Weather request failed');
        const data = await response.json();
        const [lead, description, icon] = weatherCopy(Number(data.current.weather_code));
        if (weatherTemperature) weatherTemperature.textContent = `${Math.round(data.current.temperature_2m)}°C`;
        if (weatherLead) weatherLead.textContent = lead;
        if (weatherDescription) weatherDescription.textContent = description;
        if (weatherIcon) weatherIcon.textContent = icon;
      } catch (error) {
        if (weatherDescription) weatherDescription.textContent = window.sezoniqTheme?.weatherError || 'Nie udało się pobrać pogody.';
      } finally {
        weatherButton.disabled = false;
        weatherButton.innerHTML = 'Sprawdź ponownie <span aria-hidden="true">→</span>';
      }
    }, () => {
      if (weatherDescription) weatherDescription.textContent = window.sezoniqTheme?.locationError || 'Włącz dostęp do lokalizacji.';
      weatherButton.disabled = false;
      weatherButton.innerHTML = 'Spróbuj ponownie <span aria-hidden="true">→</span>';
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  });
})();
